module.exports = __webpack_public_path__ + "static/media/abbiamo4.a7afe112.png";